module.exports = __webpack_public_path__ + "img/bank.6c4909c2.png";